import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';

// Material components
import { Grid, Typography } from '@material-ui/core';

const useStyles = makeStyles({
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
});

export function FormContainer(props) {

    const classes = useStyles();

    return (
        <Fragment>
            <Grid item xs={12} md={3} lg={4} className={classes.alignLeft}>
                <Typography variant="body1" >{props.labelText}:</Typography>
            </Grid>
            <Grid item xs={12} md={9} lg={8} className={classes.alignCenter}>
                {props.children}
            </Grid>
        </Fragment>
    );
}